import PropTypes from 'prop-types';
import legPropType from './leg';

export default PropTypes.arrayOf(legPropType);
